import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarUsuariosAdmin,
  type ListarUsuariosParams,
} from "../services/usuarios-service";

/**
 * Listado PAGINADO (server-side) de usuarios · filtros + página en el
 * queryKey. Las mutations invalidan por prefijo `qk.adminUsuarios`, que
 * cubre todas las variantes de params.
 */
export const usuariosAdminQueryOptions = (params: ListarUsuariosParams = {}) =>
  queryOptions({
    queryKey: [...qk.adminUsuarios, params] as const,
    queryFn: () => listarUsuariosAdmin(params),
    placeholderData: keepPreviousData,
  });

export const useUsuariosAdmin = (params: ListarUsuariosParams = {}) =>
  useQuery(usuariosAdminQueryOptions(params));
